import xiorInstance from '@/shared/api/instance';
import { AttemptsData, CheckData } from '@/modules/loading-page/types';

export const getCheck = async (checkID: string): Promise<CheckData> => {
  const res = await xiorInstance.get(`/checks/free/${checkID}`);

  return res.data;
};

export const getAttempts = async (): Promise<AttemptsData> => {
  const res = await xiorInstance.get(`/checks/free/limit`);

  return res.data;
};
